import { useEffect } from "react";

import LoginModal from "../../components/AuthModal/LoginModal";
import ForgotPasswordModal from "../../components/AuthModal/ResetPasswordModal";
import { useModal } from "../../context/ModalContext";
import DataUpLogo from "../../assets/images/DataUpLogoAuth.svg";
import ConfirmationModal from "../../components/AuthModal/ConfirmationModal";
import ForgotPassword from "../../assets/images/ForgotPassword.png";

const Homepage = () => {
  const { openLoginModal, closeLoginModal } = useModal();

  // Open login modal when the homepage component mounts
  useEffect(() => {
    openLoginModal();
  }, [openLoginModal]);

  return (
    <div className="w-full h-screen relative overflow-hidden">
      {/* Background Layer */}
      <div
        className="absolute inset-0"
        style={{ width: "100%", height: "100%" }}
      >
        <AuthNav />
        <img
          src={ForgotPassword}
          alt="DatauplogoAuth"
          className="w-[100%] h-[100%] object-cover md:object-fill"
        />
      </div>

      {/* Foreground Modals Layer */}
      <div className="relative z-10 flex items-center justify-center h-full p-4 overflow-y-auto">
        <div className="w-full max-w-md mx-auto flex flex-col items-center justify-center">
          <LoginModal
            closeLoginModal={closeLoginModal}
            onSuccess={closeLoginModal}
          />
          <ForgotPasswordModal />
          <ConfirmationModal />
        </div>
      </div>
    </div>
  );
};

export default Homepage;

const AuthNav = () => {
  return (
    <div className="flex justify-center items-center h-12 mb-4 bg-white dark:bg-black">
      <img
        src={DataUpLogo}
        alt="DatauplogoAuth"
        className="w-[135.55px] h-[32px]"
      />
    </div>
  );
};
